/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/

// WARNING: This barrel file exports internal APIs only for use by Presentation packages.
// They should not be used outside of these packages. These APIs may be broken or removed at any time without notice.

export { _presentation_manager_detail } from "./presentation-backend/InternalSymbols.js";
